import React, { useState , useEffect } from 'react';




const projectCategories = [
  {
    key: 'Résidentiel',
    title: "Résidentiel & habitat privé",
    description: "Appartements, villas et maisons où nous créons des ambiances authentiques, allant du contemporain minimaliste aux styles plus classiques et raffinés.",
  },
  {
    key: 'Hôtellerie & restauration',
    title: "Hôtellerie & restauration",
    description: "Décors sur mesure pour hôtels, riads, restaurants et cafés, afin de renforcer l’identité du lieu et offrir une expérience immersive aux visiteurs.",
  },
  {
    key: 'Professionnel',
    title: "Espaces professionnels & bureaux",
    description: "Solutions adaptées pour open-spaces, salles de réunion et sièges d’entreprise, combinant esthétisme, confort et acoustique.",
  },
  {
    key: 'Commercial',
    title: "Espaces commerciaux & retail",
    description: "Aménagement de showrooms, boutiques et centres commerciaux, où l’esthétique murale attire et valorise l’expérience client.",
  },
  {
    key: 'Institutionnel',
    title: "Projets institutionnels & éducatifs",
    description: "Habillage décoratif et fonctionnel pour établissements scolaires, universités et espaces publics, avec des matériaux durables et faciles à entretenir.",
  },
];

const projectsData = [
  {
    id: 1,
    title: 'Villa contemporaine',
    category: 'Résidentiel',
    image: 'https://adawall.ma/uploads/projets/villa.jpg',
    details: `Ambiance élégante et chaleureuse dans cette villa moderne grâce à nos papiers peints haut de gamme.`,
  },
  {
    id: 2,
    title: 'Hôtel de Luxe',
    category: 'Hôtellerie & restauration',
    image: 'https://adawall.ma/uploads/projets/hotel.webp',
    details: `Un hôtel où chaque espace a été pensé pour offrir confort et élégance. Les revêtements AdaWall créent une atmosphère accueillante.`,
  },
  {
    id: 3,
    title: 'Café branché',
    category: 'Hôtellerie & restauration',
    image: 'https://adawall.ma/uploads/projets/café.webp',
    details: `Un café moderne où le design intérieur crée une ambiance conviviale et unique, grâce à nos papiers peints personnalisés.`,
  },
  {
    id: 4,
    title: 'Restaurant chic',
    category: 'Hôtellerie & restauration',
    image: 'https://adawall.ma/uploads/projets/restaurant.jpg',
    details: `Un restaurant chic mettant en valeur l'excellence du savoir-faire AdaWall, pour une expérience gastronomique dans un cadre élégant.`,
  },
  {
    id: 5,
    title: 'Open-space moderne',
    category: 'Professionnel',
    image: 'https://adawall.ma/uploads/projets/bureau.jpg',
    details: `Un open-space lumineux et acoustique, favorisant la créativité et le bien-être au travail.`,
  },
  {
    id: 6,
    title: 'Boutique tendance',
    category: 'Commercial',
    image: 'https://adawall.ma/uploads/projets/boutique.webp',
    details: `Showroom où l’esthétique murale attire et valorise l’expérience client.`,
  },
  {
    id: 7,
    title: 'École maternelle',
    category: 'Institutionnel',
    image: 'https://adawall.ma/uploads/projets/ecole maternelle.jpg',
    details: `Habillage décoratif et fonctionnel pour un espace éducatif accueillant et durable.`,
  },
  // ...ajoute d'autres projets selon les catégories...
];



function Projects() {
  const [selectedCategory, setSelectedCategory] = useState('Tout');

    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filteredProjects =
    selectedCategory === 'Tout'
      ? projectsData
      : projectsData.filter(p => p.category === selectedCategory);


  
  return (
    <>
    <section className="projects-section">
      {/* Texte introductif */}
      <div className="projects-intro" style={{maxWidth: 900, margin: "0 auto 36px auto", padding: "32px 18px 18px 18px"}}>
        <h1 style={{fontSize: "2.2rem", color: "#01367B", fontWeight: 700, textAlign: "center", marginBottom: 18}}>Nos Projets Réalisés</h1>
        <p style={{fontSize: "1.15rem", color: "#2E2E2E", textAlign: "center", marginBottom: 18}}>
          Chez <b>Adawall Maroc</b>, chaque projet est une histoire unique où design, qualité et savoir-faire se rencontrent. De la conception à la pose, nous accompagnons nos clients dans la création d’espaces qui reflètent leur personnalité et valorisent leur cadre de vie ou de travail. Nos collections de papiers peints, bardages et moulures permettent de transformer chaque intérieur en un lieu élégant, chaleureux et durable.
        </p>
      </div>

      {/* Filtres */}
      <div className="projects-filters" style={{marginBottom: 32}}>
        <button
          className={selectedCategory === 'Tout' ? 'active' : ''}
          onClick={() => setSelectedCategory('Tout')}
        >
          Tous les projets
        </button>
        {projectCategories.map(cat => (
          <button
            key={cat.key}
            className={selectedCategory === cat.key ? 'active' : ''}
            onClick={() => setSelectedCategory(cat.key)}
          >
            {cat.title}
          </button>
        ))}
      </div>

      {/* Liste des projets */}
      <div className="projects-list">
        {filteredProjects.length === 0 ? (
          <div style={{textAlign: "center", color: "#96292A", fontWeight: 500, fontSize: "1.1rem"}}>Aucun projet pour cette catégorie.</div>
        ) : (
          filteredProjects.map((project, idx) => (
            <div
              className={`project-row ${idx % 2 === 0 ? 'normal' : 'reverse'}`}
              key={project.id}
            >
              <div className="project-img-col">
                <img src={project.image} alt={project.title} />
              </div>
              <div className="project-text-col">
                <h2>{project.title}</h2>
                <span className="category">{project.category}</span>
                <p>{project.details}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </section>
    <a
        href="https://wa.me/212664664692"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="/assets/icons/whatsapp.png"
          alt="WhatsApp"
          style={{ width: 40, height: 40 }}
        />
      </a>
      </>
  );
}

export default Projects;